module.exports = __webpack_public_path__ + "assets/5dc4dc948340efcc7d77e75d391342c9.mp3";